import styled from "styled-components";

interface ColorSwatchProps {
	colors: string[];
}

const StyledColorSwatch = styled.div`
  display: flex;
  gap: 2px;
`;

const SwatchDot = styled.div<{ $color: string }>`
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background-color: ${(props) => props.$color};
  border: 1px solid rgba(0, 0, 0, 0.1);
`;

function ColorSwatch({ colors }: ColorSwatchProps) {
	return (
		<StyledColorSwatch>
			{colors.map((color, index) => (
				<SwatchDot key={`${color}-${index}`} $color={color} />
			))}
		</StyledColorSwatch>
	);
}

export default ColorSwatch;
